/**
 * "240 kB", "1,8 MB" — de grootte van een bijlage, zoals ze op een kaart past.
 *
 * Waarom dit een functie is en geen `Math.round(bytes / 1024) + ' kB'` op de plek zelf: die regel
 * stond op drie plaatsen in de app, en op alle drie zei ze "kB" — ook bij een video van veertig
 * megabyte, die dan als "40960 kB" op het scherm kwam. Voor een medewerker op mobiele data is dat
 * precies het getal dat hij moet kunnen lezen voordat hij tikt.
 *
 * Kilo is hier 1000 en niet 1024: het is de maat die een telefoon en een bestandsbeheerder ook
 * tonen, en het verschil met wat de medewerker elders ziet is erger dan de onnauwkeurigheid.
 */
export function fileSizeLabel(sizeBytes: number, locale = 'nl-BE'): string {
  if (sizeBytes < 1000) return `${Math.max(1, sizeBytes)} B`;

  const kilobytes = sizeBytes / 1000;
  if (kilobytes < 1000) return `${Math.round(kilobytes)} kB`;

  // Eén cijfer na de komma vanaf een megabyte: "1,8 MB" zegt meer dan "2 MB", en "1,84 MB" niet
  // meer dan "1,8 MB".
  return `${(kilobytes / 1000).toLocaleString(locale, { maximumFractionDigits: 1 })} MB`;
}
